import { Component, Shark } from "shark-mvc";

import templateContent from "./wait-box.html";

class WaitBoxComponent extends Component {
	constructor () {
		super("waitBoxComponent");

		this.addTemplate("", templateContent);
	}

	close () {
		Shark.set({
			waitBoxOpen: false,
		});
	}

	init () {
		Shark.set({
			waitBoxOpen: false,
		});
	}
	
	open () {
		Shark.set({
			waitBoxOpen: true,
		});
	}
}

const waitBoxComponent = new WaitBoxComponent();

Shark.registerComponent(waitBoxComponent);

export default waitBoxComponent;